import { FrameProfileV2 } from './FrameProfile';
import { ShapeType } from './Shape';
import { FrameParameters } from './FrameParameters';

/** Rama konstrukcji */
export class FrameV2 {
    /** Identyfikator */
    id: number;
    /** Indeks */
    index: number;
    /** Pozycja x [mm] */
    x: number;
    /** Pozycja y [mm] */
    y: number;
    /** Szerokość [mm] */
    width: number;
    /** Wysokość [mm] */
    height: number;
    /** Profile ramy */
    frame: FrameProfileV2[] = [];
    /** Czy rama ma niski próg */
    lowThreshold = false;
    /** Kształt ramy */
    shape: ShapeType = 'rect';
    /** Parametry */
    parameters: FrameParameters = {
        ap: null,
        g: null,
        lt: null,
        rw: null,
        ug: null,
        uw: null,
        sw: null,
        weight: null,
        wl: null,
        wp: null,
        lab: null,
    };

    constructor({
        id,
        index,
        x,
        y,
        width,
        height,
    }: {
        id: number;
        index: number;
        x: number;
        y: number;
        width: number;
        height: number;
    }) {
        this.id = id;
        this.index = index;
        this.x = x;
        this.y = y;
        this.width = width;
        this.height = height;
    }
}
